import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle"; // Fixing this import as well
import logo from "../../assets/images/logo-main-white.png";
import {
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Popover,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
} from "@mui/material"; // Correct imports from MUI
import { makeStyles } from '@mui/styles';
import AppsIcon from "@mui/icons-material/Apps";
import accessToken from "../../helpers/jwt-token-access/accessToken";
import { jwtDecode } from "jwt-decode";
import { Button } from "reactstrap";

const Layout = (props) => {

  // console.log("Theme inside Layout: ", theme); // Log the theme here to verify if it's being passed

  const useStyles = makeStyles((theme) => ({
    megaMenu: {
      display: "flex",
      flexDirection: "row",
      backgroundColor: "aliceblue",
      padding: "0.5rem",
    },
    megaMenuCategory: {
      display: "flex",
      flexDirection: "column",
      margin: "0 20px",
    },
    megaMenuCategoryTitle: {
      fontWeight: "bold",
    },
    megaMenuOptions: {
      display: "flex",
      flexDirection: "column",
      marginTop: "10px",
    },
    megaMenuButton: {
      margin: "5px 0",
    },
    appBar: {
      backgroundColor: "#193a6f",
    },
    activeButton: {
      color: "white",
      marginLeft: "auto",
      textDecoration: "none",
      backgroundColor: "#f98125",
    },
    logo: {
      maxWidth: 160,
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper, // Using theme
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  }));
  
  const classes = useStyles(); // Keep this after defining useStyles
  

  useEffect(() => {
    let currentage = capitalizeFirstLetter(props.location.pathname);
    document.title = currentage + " | CloudNova App";
  }, [props.location.pathname]);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const token = accessToken();
  const decoded = jwtDecode(token);
  const userName = decoded["email"];
  const userRole = decoded["cognito:groups"];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAnchor = () => {
    setAnchorEl(null);
  };

  const openAnchor = Boolean(anchorEl);
  const id = openAnchor ? "simple-popover" : undefined;

  const [menuOpen, setMenuOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <React.Fragment>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Link to="/details">
            <img src={logo} alt="logo" className={classes.logo} />
          </Link>
          <Divider orientation="vertical" flexItem color="white" variant="middle" style={{ marginLeft: "1rem" }} />
          <div ref={anchorRef}>
            <IconButton color="inherit" onClick={handleMenuClick}>
              <AppsIcon fontSize="large" />
            </IconButton>
            <Popover
              id={id}
              open={menuOpen}
              onClose={closeMenu}
              anchorEl={anchorRef.current}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              PaperProps={{
                style: { backgroundColor: "#193a6f" },
              }}
            >
              <div className={classes.megaMenu}>
                <div className={classes.megaMenuCategory}>
                  <Typography variant="subtitle1" className={classes.megaMenuCategoryTitle}>
                    CloudCatcher
                  </Typography>
                  <div className={classes.megaMenuOptions}>
                    <Link to="/organization" onClick={closeMenu}>
                      <Button className={classes.megaMenuButton}>Organization Management</Button>
                    </Link>
                  </div>
                  <div className={classes.megaMenuOptions}>
                    <Link to="/malwarescan" onClick={closeMenu}>
                      <Button className={classes.megaMenuButton}>Malware Scan History</Button>
                    </Link>
                  </div>
                </div>
                <div className={classes.megaMenuCategory}>
                  <Typography variant="subtitle1" className={classes.megaMenuCategoryTitle}>
                    Global License Manager
                  </Typography>
                  <div className={classes.megaMenuOptions}>
                    <Link to="/globallicensemanager" onClick={closeMenu}>
                      <Button className={classes.megaMenuButton}>License Management</Button>
                    </Link>
                  </div>
                  <div className={classes.megaMenuOptions}>
                    <Link to="/globaliaacmanager" onClick={closeMenu}>
                      <Button className={classes.megaMenuButton}>IaaC Manager</Button>
                    </Link>
                  </div>
                </div>
                {userRole.includes("Admin") && (
                  <div className={classes.megaMenuCategory}>
                    <Typography variant="subtitle1" className={classes.megaMenuCategoryTitle}>
                      User Management
                    </Typography>
                    <div className={classes.megaMenuOptions}>
                      <Link to="/users" onClick={closeMenu}>
                        <Button className={classes.megaMenuButton}>Manage Cognito Users</Button>
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </Popover>
          </div>
          <div style={{ flexGrow: 1 }} />
          <div>
            <Tooltip title={userName} placement="bottom">
              <IconButton color="inherit" onClick={handleClick}>
                <AccountCircleIcon />
              </IconButton>
            </Tooltip>
            <Popover
              id={id}
              open={openAnchor}
              anchorEl={anchorEl}
              onClose={handleCloseAnchor}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              PaperProps={{
                style: { backgroundColor: "#193a6f" },
              }}
            >
              <List>
                <ListItem className={classes.activeButton}>
                  <ListItemText primary={userName} />
                </ListItem>
                <Link className={classes.activeButton} to="/logout">
                  <ListItem button>
                    <ListItemText primary="Log Out" />
                  </ListItem>
                </Link>
              </List>
            </Popover>
          </div>
        </Toolbar>
      </AppBar>
      {props.children}
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  return {
    ...state.layout,
  };
};
export default connect(mapStatetoProps, null)(withRouter(Layout));
